import { Theme } from '@emotion/react';
import { ThemeProvider } from '@mui/material';
import { formatWorkflow, getTheme } from '@parsys/frontend_library';
import { ThemeOptions } from '@parsys/frontend_library/lib/themes/themes.types';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import DrugReferencesTable from './DrugReferencesTable';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';

export default (element, store) => {
  const root = createRoot(element);
  const theme = getTheme({ app: THEME_APP_NAME, branding: window.branding } as ThemeOptions) as Theme;

  const rawWorkflowsWithAdminRoutes = JSON.parse(element.dataset.workflows || '[]');

  const formatedWorkflowsWithRoutes = rawWorkflowsWithAdminRoutes.map((workflow) => ({
    workflow: formatWorkflow(workflow.workflow, {}),
    administrationRoutes: workflow.administration_routes,
  }));


  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <DrugReferencesTable workflowsWithRoutes={formatedWorkflowsWithRoutes} />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>,
  );

  return () => {
    root.unmount();
  };
};
